import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import axiosMock from 'src/utils/axios';
// import { isAuthenticated, JWT_SECRET, COOKIE_SECRET } from 'src/utils/jwt';
import PropTypes from 'prop-types';
import ls from 'localstorage-slim';
import { EncryptStorage } from 'encrypt-storage';
import { useNavigate } from "react-router-dom";
import { reloadMenus } from 'src/layouts/AllMenuItems';
import { useDispatch, useSelector } from 'react-redux';
import {shop as shopReducer} from '../redux/shopSlice';
import {shops as shopsReducer} from '../redux/shopsSlice';
import {user as userReducer} from '../redux/userSlice';
import {orders as ordersReducer} from '../redux/ordersSlice';

// require('dotenv').config();

export const encryptSessionStorage = new EncryptStorage(process.env.REACT_APP_COOKIE_SECRET, {
    storageType: 'sessionStorage'
});

export const encryptLocalStorage = new EncryptStorage(process.env.REACT_APP_COOKIE_SECRET, {
    storageType: 'localStorage'
});

const dotenv = require('dotenv');

dotenv.config({ path: '.env' }); 

ls.config.encrypt = true; // set up encryption/obfuscation globally
// ls.config.secret = COOKIE_SECRET; // set Decryption Key
ls.config.secret = process.env.REACT_APP_COOKIE_SECRET; // set Decryption Key

const initialAuthState = {
    isAuthenticated: false,
    isInitialized: false,
    user: ''
};

const setSession = (accessToken) => {
    if (accessToken) {
        encryptSessionStorage.setItem('accessToken', accessToken);
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        axiosMock.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
        encryptSessionStorage.removeItem('accessToken');
        delete axios.defaults.headers.common.Authorization;
        delete axiosMock.defaults.headers.common.Authorization;
    }
};

const handlers = {
    INITIALIZE: (state, action) => {
        const { isAuthenticated, user } = action.payload;

        return {
            ...state,
            isAuthenticated,
            isInitialized: true,
            user
        };
    },
    LOGIN: (state, action) => {
        const { user } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user
        };
    },
    LOGOUT: (state) => ({
        ...state,
        isAuthenticated: false,
        user: ''
    }),
    REGISTER: (state, action) => {
        const { user } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user
        };
    }
};

const reducer = (state, action) =>
    handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
    ...initialAuthState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    register: () => Promise.resolve()
});

export const AuthProvider = (props) => {
    const { children } = props;
    const [state, dispatch] = useReducer(reducer, initialAuthState);
    const dispatch2 = useDispatch();
    const shop = useSelector((state)=> state.shop);
    const shops = useSelector((state)=> state.shops);

    const navigate = useNavigate();

    useEffect(() => {
        if(!shop){
            if(shops && Array.isArray(shops) && shops.length > 0){
                if(shops.length === 1){
                    dispatch2(shopReducer(shops[0]));
                    navigate('/extended-sidebar/reports');
                }else{
                    navigate('/extended-sidebar/shop/active');
                }
            }else{ 
                navigate('/extended-sidebar/');
            }
        }

        const initialize = async () => {
            try {
                const accessToken = encryptSessionStorage.getItem('accessToken');
                // if (accessToken && isAuthenticated(accessToken, JWT_SECRET)) {
                if (accessToken) {
                    setSession(accessToken);

                    const response = await axiosMock.get(
                        '/api/account/personal'
                    );
                    const { user } = response.data;
                    dispatch({
                        type: 'INITIALIZE',
                        payload: {
                            isAuthenticated: true,
                            user
                        }
                    });
                } else {
                    dispatch({
                        type: 'INITIALIZE',
                        payload: {
                            isAuthenticated: false,
                            user: ''
                        }
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: 'INITIALIZE',
                    payload: {
                        isAuthenticated: false,
                        user: ''
                    }
                });
            }
        };

        initialize();
    }, []);

    const login = async (username, password) => {
        try{
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`,{
                username,
                password
            });

            if(res.status === +process.env.REACT_APP_RECORD_NOT_FOUND){ // no prod
                // eslint-disable-next-line 
                alert('Incorrect username and/or password. Please double check and try again or use the forgot password link')
            }else{
                const { error, message } = res.data;
    
                if(!error){
                    const { accessToken, user } = res.data.data;
                    const appDetails = JSON.parse(process.env.REACT_APP_APP_DETAILS);
                    
                    if(user.role === 'general'){
                        // eslint-disable-next-line 
                        alert('Access Denied For Non Merchant Users');
                        window.location.href = appDetails.publicUrl;
                    }else{
                        localStorage.setItem('user', JSON.stringify(user));
                        dispatch2(userReducer(user));
    
                        const shopRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/shop`,{
                            headers:{
                                Authorization: `Bearer ${accessToken}`
                            }
                        });
                        const { error, data } = shopRes.data;
                     
                        if(!error && Array.isArray(data) && data.length > 0){
                            dispatch2(shopReducer(data[0]));
                            dispatch2(shopsReducer(data));
                        }
    
                        // await loadReportDetails(accessToken); 
                        await loadOrders({token: accessToken, shop: data[0]});
                
                        setSession(accessToken);
                        dispatch({
                            type: 'LOGIN',
                            payload: { 
                                user
                            }
                        });
                        reloadMenus();    
                    }
                }else{
                    // eslint-disable-next-line
                    alert(message);
                }
            }
    
        }catch(err){
            const message = err?.response?.data?.message || err.message;
            console.error(err, err.response);
            // eslint-disable-next-line
            alert(message);
        }
    };

    const logout = async () => {
        setSession(null);
        dispatch({ type: 'LOGOUT' });
    };

    // const register = async (email, name, password) => {
    //     const response = await axiosMock.post('/api/account/register', {
    //         email,
    //         name,
    //         password
    //     });
    //     const { accessToken, user } = response.data;

    //     window.localStorage.setItem('accessToken', accessToken);
    //     dispatch({
    //         type: 'REGISTER',
    //         payload: {
    //             user
    //         }
    //     });
    // };

    const loadOrders = async ({token, shop}) => {
        try{
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/order?shopSlug=${shop.slug}&page=1&size=1000000`,{
                    headers: {
                      'Authorization': `Bearer ${token}` 
                    }
                }
            );

            if(res.status !== +process.env.REACT_APP_RECORD_NOT_FOUND){
                const { error, data } = res.data;

                if(!error && Array.isArray(data)){
                    dispatch2(ordersReducer(data));
                }else{
                    dispatch2(ordersReducer([]));             
                } 
            }   
        }catch(err){
            console.error(err);
            dispatch2(ordersReducer([]));
        }
    };

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                login,
                logout,
                // register
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default AuthContext;